var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound"},[_c('img',{attrs:{"src":require("../assets/images/icon_blank.png")}}),_c('p',{staticClass:"text"},[_vm._v("页面不存在~")])])
}]

export { render, staticRenderFns }